import { caseComponentsLib } from '@/Constants/caseComponentsLib/caseComponentsLib';
import { drawerSeparators } from '@/Constants/caseComponentsLib/drawerSeparators';

export function getPrototypeByID(id: string) {
    const item = caseComponentsLib.find(item => item.id === id);
    if (item) {
        return item;
    }
    return undefined;
}

export function getDrawerSeparatorsByDrawerId(drawerId: string) {
    return drawerSeparators
        .filter(item => item.applicableDrawerIds.includes(drawerId));
}
